class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
           
          }).then(function(){
            initSlider();
            productCard();
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this)).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  function checkSliderAlone(){
    if ( this.slides.length) {
            this.slides.length < 2
            ? this.element.classList.add('flickity-is-single')
            : this.element.classList.remove('flickity-is-single')
    }
  }


  function initSlider(){
    
    var arrowShape = 'M21.8,49.36a1.51,1.51,0,0,1,.36-.54L38.82,32.16a1.67,1.67,0,1,1,2.36,2.35L27.36,48.33H76.67a1.67,1.67,0,0,1,0,3.34H27.36L41.18,65.49a1.67,1.67,0,0,1,0,2.36,1.69,1.69,0,0,1-2.36,0L22.16,51.18h0a1.62,1.62,0,0,1-.35-.54,1.64,1.64,0,0,1,0-1.28Z';

    var elem = document.querySelectorAll('.product-recommendations  .carousel');

    elem.forEach( elem => {

      var dynamicAssets = elem.querySelectorAll('[loading="lazy"]'); // dynamically added content
      console.log(dynamicAssets);
      new LazyLoad(dynamicAssets);  
      new Flickity( elem, {
              cellSelector: '.carousel__item',
              cellAlign: 'center',
              contain: false,
              dragThreshold: 10,
              selectedAttraction: 0.01,
              friction: 0.18,
              wrapAround: false,
              initialIndex: '.initial-index',
              pageDots: true,
              adaptiveHeight: true,
              arrowShape:arrowShape,
              watchCSS:true,
              on: {
                      ready: checkSliderAlone,
                      resize: checkSliderAlone
                      }
      });

      function checkSliderAlone(){

        
       

        if ( this.slides.length) {
                this.slides.length < 2
                ? this.element.classList.add('flickity-is-single')
                : this.element.classList.remove('flickity-is-single')
        }
}
});

  }